<template>

  <main class="main-content" id="topDom">
    <section class="section">
      <ul class="breadcrumb">
        <li class="breadcrumb__li --current">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
        </li>
        <li class="breadcrumb__li --current">
          <router-link to="/about" class="breadcrumb__link">{{ $t("i18n.about") }}</router-link>
        </li>
        <li class="breadcrumb__li">
          <span class="breadcrumb__text"> {{ $t("i18n.developmentPath") }}</span>
        </li>
      </ul>

      <div class="banner" style="cursor: pointer;" :style="{height: (isMobile() ? (windowHeight - 110) + 'px !important' : '61rem')}">
        <img class="mobileBg" v-if="isMobile()" :src="imageSrc" />
        <div class="banner__content container-fluid" v-if="!isMobile()">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title" style="color: #ffffff;font-size: 3rem;letter-spacing: 2px;text-wrap: nowrap">{{ $t("i18n.CompanyProfilePageTitle") }}</h1>
              <p class="banner__text" v-html="$t('i18n.CompanyProfilePageText')"></p>
            </div>
          </div>
        </div>
        <div class="banner__bg" v-if="!isMobile()">
          <img :src="imgUrlBg" />
        </div>
      </div>
    </section>

    <section class="section --banner">
      
      <!-- <div class="banner"> -->
        <!-- <div class="banner__bg"> -->
          <!-- <img :src="imgUrl" alt="" style="width: 100%;"> -->
          <img :src="$t('i18n.developementImg')" alt="" style="width: 100%;">
        <!-- </div> -->

        <!-- <div class="banner__content container-fluid --content">
          <div class="banner__content container-fluid --main">
            <div class="row align-items-center">
              <div class="col-12 col-md-6 order-2 order-md-1 main-page">
                <div class="main_content">
                  <h1 class="banner__title">{{ $t("i18n.developmentPath") }}</h1>
                  <p class="banner__text" style="margin-top: auto;color: #6c6c6c;">{{ $t("i18n.developmentPathPageTitle") }}</p>
                </div>
                <p class="banner__text" v-html="$t('i18n.developmentPathPageText')"></p>
              </div>
            </div>
          </div>
          <div class="tmlinDiv" style="display: flex;width: 60vw;justify-content: space-between;margin-left: -9rem;">
            <div :class="index==4?'timelines':index==5?'timelines2':index==6?'timelines3':'timeline'" :style="index==4?`bottom:${(index)*8}rem;margin-left:10rem;`:index==5?`bottom:${(index)*7}rem;`:index==6?`bottom:${(index)*6.5}rem;`:`bottom:${(index)*7}rem;`"  v-for="(item,index) in timeLine ">
              <ul>
                <li>
                  <div class="dot"></div>
                  <span :class="index==6?'years':'year'">{{ item.time }}</span>
                  <div :class="index==4?'event-contents':index==5?'event-contents':index==6?'event-contents event-contentsTop':'event-content'" :data-after="item.dataAfter_1">
                  </div>
                  <div :class="index==4?'event-content-twos':index==5?'event-content-twos':index==6?'event-content-twos event-contentsTop':'event-content-two'" :data-after="item.dataAfter_2" v-show="item.dataAfter_2">
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div> -->
      <!-- </div> -->
    </section>
  </main>
</template>

<script>
export default {
  name: "developmentPath",
  data() {
    return {
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      imgUrlBg: this.isMobile() ? require("../assets/imgs/aboutBgImg-p.png") : require("../assets/imgs/about-nei.png"),
      // imgUrl: this.isMobile() ? require("../assets/imgs/developmentHistory.jpg") : require("../assets/imgs/developmentHistory.jpg"),
      timeLine:[{
        time:'2018年',
        dataAfter_1:'与韩国第一真空阀 门PRESYS战略合作',
        dataAfter_2:'阀门维修'
      },{
        time:'2019年',
        dataAfter_1:'投标购地',
        dataAfter_2:'成为中微半导体合作单位'
      },{
        time:'2020年',
        dataAfter_1:'公司基建',
        dataAfter_2:'成为拓荆科技合作单位'
      },{
        time:'2021年',
        dataAfter_1:'首样国产化插板阀、角阀 在客户验证通过',
        // dataAfter_2:'阀门维修'
      },{
        time:'2022年',
        dataAfter_1:'建成投产',
        dataAfter_2:'北京亦庄研发中心正式成立'
      },{
        time:'2023年',
        dataAfter_1:'成为北方华创阀门唯一维修单位',
        dataAfter_2:'成为国产化真空阀门主要供应商'
      },{
        time:'未来',
        dataAfter_1:'高速发展成为国内 真空阀门头部企业',
      }]
    }
  },
  // created() {
  //   this.goTop();
  // },
  mounted () {
    this.goTop();
  },
  computed: {
    imageSrc() {
      // 从i18n获取baseUrl，并拼接图片名称
      return this.$t('i18n.bannerBg6');
    }
  },
  methods: {
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    goPage(path) {
      this.$router.push(path)
    },
    goTop() {
      // window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      document.querySelector('#topDom').scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.container-fluid.--main {
  margin-bottom: 65rem;
  margin-right: 50rem;
}
.container-fluid.--content {
  margin-right: 2rem;
  /* margin-left: 2rem; */
  margin: 0 auto
}
.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #e3e3e3;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li.--current:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #FFFFFF;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.banner {
  position: relative;
  width: 100%;
  height: 61rem;
  align-items: center;
  display: flex;
  background-image: url(../assets/imgs/5-bg.png);
  background-size: cover; /* 保证背景图片覆盖元素并且不变形 */
  background-position: center; /* 将背景图片居中显示 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  padding: 15rem 0 0 0;
  display: flex;
  flex-direction: column;
}
.banner__bg {
  /* position: absolute;
  width: 100%;
  height: 61rem; */
  /* margin-top: -18rem; */
  position: absolute;
  bottom: 0;
  margin-top: 1rem;
}
.banner__bg {
  z-index: 1;
}
.banner__bg img {
  /* max-width: 100%; */

  display: block;
  width: 100%;
  /* height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%; */
}

.banner__content {
  /* position: relative; */
  position: absolute;
  top: 15%;
  z-index: 2;
}
.banner__title {
  font-weight: 500;
  font-size: 4rem;
  color: #fff;
  letter-spacing: -.084rem;
  line-height: 6rem;
}
.banner__text {
  margin-top: 3rem;
  font-size: 2.1rem;
  font-weight: 500;
  color: #fff;
  letter-spacing: -.022rem;
  line-height: 3.3rem;
  padding-right: 2rem;
}
.main_content {
  display: flex;
}
.main_content p {
  padding-left: 2rem;
  font-weight: normal;
}
.main-page .banner__text{
  color: black;
  letter-spacing: 2px;
}

.timeline {
  position: relative;
  max-width: 2rem;
  background: red;
  margin: 2rem auto;
  margin-right: 25rem

}

.timeline::before {
  content: "";
  position: absolute;
  bottom: 1rem;
  left: .9rem;
  width: .2rem;
  height: 23rem;
  background-color: #6C2188;
}
.timelines {
  position: relative;
  max-width: 2rem;
  background: red;
  margin: 2rem auto;
}

.timelines::before {
  content: "";
  position: absolute;
  bottom: 1rem;
  left: .9rem;
  width: .2rem;
  height: 30rem;
  background-color: #6C2188;
}
.timelines2 {
  position: relative;
  max-width: 2rem;
  background: red;
  margin: 2rem auto;
  margin-left: 22rem
}

.timelines2::before {
  content: "";
  position: absolute;
  bottom: 1rem;
  left: .9rem;
  width: .2rem;
  height: 35rem;
  background-color: #6C2188;
}
.timelines3 {
  position: relative;
  max-width: 2rem;
  background: red;
  margin: 2rem auto;
  margin-left: 22rem
}

.timelines3::before {
  content: "";
  position: absolute;
  bottom: 1rem;
  left: .9rem;
  width: .2rem;
  height: 40rem;
  background-color: #6C2188;
}
.event-content, .event-content-two {
  width: 100%;
  text-wrap: nowrap;
}
.event-content::after {
  content: attr(data-after);
  position: absolute;
  bottom: 19rem;
  height: auto;
  left: 4rem;
  width: 10rem;
  font-weight: normal;
  font-size: 1.2rem;
  color: #231815;
  line-height: 2rem;
}
.event-content::before {
  content: "";
  position: absolute;
  z-index: 2;
  left: 2rem;
  bottom: 19.5rem;
  width: 1rem;
  height: 1rem;
  margin-top: -.4rem;
  background: transparent;
  border: .2rem solid #6C2188;
  box-sizing: border-box;
  border-radius: .5rem;
}

.event-content-two::after {
  content: attr(data-after);
  position: absolute;
  bottom: 15rem;
  height: auto;
  left: 4rem;
  width: 10rem;
  font-weight: normal;
  font-size: 1.2rem;
  color: #231815;
  line-height: 2rem;
}
.event-content-two::before {
  content: "";
  position: absolute;
  z-index: 2;
  left: 2rem;
  bottom: 15.6rem;

  width: 1rem;
  height: 1rem;
  margin-top: -.4rem;
  background: transparent;
  border: .2rem solid #6C2188;
  box-sizing: border-box;
  border-radius: .5rem;
}
.event-contents, .event-content-twos {
  width: 100%;
  text-wrap: nowrap;
}
.event-contents::after {
  content: attr(data-after);
  position: absolute;
  bottom: 28rem;
  height: auto;
  right: 1.5rem;
  /* width: 10rem; */
  font-weight: normal;
  font-size: 1.2rem;
  color: #231815;
  line-height: 2rem;
}
.event-contents::before {
  content: "";
  position: absolute;
  z-index: 2;
  right: 0;
  bottom: 28.5rem;
  width: 1rem;
  height: 1rem;
  margin-top: -.4rem;
  background: transparent;
  border: .2rem solid #6C2188;
  box-sizing: border-box;
  border-radius: .5rem;
}

.event-content-twos::after {
  content: attr(data-after);
  position: absolute;
  bottom: 24rem;
  height: auto;
  right: 1.5rem;
  /* width: 10rem; */
  font-weight: normal;
  font-size: 1.2rem;
  color: #231815;
  line-height: 2rem;
}
.event-content-twos::before {
  content: "";
  position: absolute;
  z-index: 2;
  right: 0;
  bottom: 24.6rem;
  width: 1rem;
  height: 1rem;
  margin-top: -.4rem;
  background: transparent;
  border: .2rem solid #6C2188;
  box-sizing: border-box;
  border-radius: .5rem;
}
.event-contentsTop::after{
  bottom: 36rem !important;
}
.event-contentsTop::before{
  bottom: 36.6rem !important;
}
.timeline ul {
  list-style-type: none;
  padding-left: 0;
}

.timeline li {
  display: flex;
  align-items: center;
  position: relative;
}

.year {
  color: #6C2188;
  position: absolute;
  font-size: 1.5rem;
  font-family: Alibaba;
  font-weight: normal;
  left: -4.4rem;
  bottom: 1rem;
  text-wrap: nowrap;
}
.years {
  color: #6C2188;
  position: absolute;
  font-size: 1.5rem;
  font-family: Alibaba;
  font-weight: normal;
  right: -4.4rem;
  bottom: 1rem;
  text-wrap: nowrap;
}

/* 时间点 */
.dot {

  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 2rem;
  height: 2rem;
  background-color: #6C2188;
  border-radius: 50%;
  z-index: 1;
}
.dot:hover {
  transform: scale(1.9); /* 放大到110% */
  transition: transform 0.3s; /* 添加过渡效果，持续0.3秒 */
}


@media (max-width: 768px)
{
body {
  overflow-x: scroll !important;
}

.banner {
    /* margin-top: -110px; */
    padding-top: 0rem;
    width: 100%;
    background-image: none !important;
    overflow:hidden;
  }
  .mobileBg {
    display: block;
    width: 100%;
    height: auto;
  } 

.tmlinDiv {
  width: 80vw;
  transform: scale(0.4); /* 放大到110% */
position: absolute;
  bottom: 5rem;
  left: -10rem;
}
  .timeline {
   margin-right: 15rem;
  }
  .banner__title{
    font-size: 1.8rem !important;
    text-wrap: wrap !important;
    line-height: 2.5rem;
  }
  .banner__text{
    font-size: 1.6rem !important;
    line-height: 2.5rem;
  }
}


</style>



// WEBPACK FOOTER //
// src/view/developmentPath.vue